export default function IconEyeSlash() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="24"
      viewBox="0 0 30 24"
    >
      <path
        id="eye_slash"
        d="M29.766,1.078a.745.745,0,0,1,.094,1.078l-.469.563a.693.693,0,0,1-1.031.094L.328-19.078a.756.756,0,0,1-.281-.609.751.751,0,0,1,.188-.469L.7-20.719A.631.631,0,0,1,1.266-21a.636.636,0,0,1,.469.188Zm-15.8-15.234a6.019,6.019,0,0,1,1.078-.094,5.039,5.039,0,0,1,3.633,1.477A5.144,5.144,0,0,1,20.3-9.187ZM16.125-3.844a6.019,6.019,0,0,1-1.078.094,5.039,5.039,0,0,1-3.633-1.477A5.144,5.144,0,0,1,9.8-8.812ZM15.047-15.75a12.38,12.38,0,0,0-2.719.328l-2.2-1.687A14.513,14.513,0,0,1,15.047-18a14.261,14.261,0,0,1,7.828,2.273A15.662,15.662,0,0,1,28.406-9.7a1.766,1.766,0,0,1,.141.7,1.766,1.766,0,0,1-.141.7,17.422,17.422,0,0,1-2.484,3.516L24.141-6.187A13.034,13.034,0,0,0,26.2-9a13.036,13.036,0,0,0-4.711-4.945A12.209,12.209,0,0,0,15.047-15.75Zm0,13.5a12.38,12.38,0,0,0,2.719-.328l2.2,1.688A14.513,14.513,0,0,1,15.047,0,14.261,14.261,0,0,1,7.219-2.273,15.662,15.662,0,0,1,1.688-8.3,1.766,1.766,0,0,1,1.547-9a1.766,1.766,0,0,1,.141-.7,17.422,17.422,0,0,1,2.484-3.516l1.781,1.406A13.034,13.034,0,0,0,3.891-9,13.036,13.036,0,0,0,8.6-4.055,12.209,12.209,0,0,0,15.047-2.25Z"
        transform="translate(-0.047 21)"
        fill="#707070"
      />
    </svg>
  );
}
